<div class="premium-modal-content">
  <button class="close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>

  <div class="premium-header">
    <div class="icon-container" [ngClass]="{'success-bg': isSuccess}">
      <mat-icon *ngIf="!iconClass?.startsWith('fa')" [ngClass]="{'success-icon': isSuccess, 'default-icon': !isSuccess}">{{ iconClass || 'notifications' }}</mat-icon>
      <i *ngIf="iconClass?.startsWith('fa')" [class]="iconClass" [ngClass]="{'success-icon': isSuccess, 'default-icon': !isSuccess}"></i>
    </div>
  </div>

  <div class="premium-body">
    <h3 class="premium-title">{{ mainTitle }}</h3>
    <p class="premium-message" [innerHTML]="title"></p>
  </div>
  
  <div class="premium-actions">
    <button class="btn-action btn-secondary" mat-dialog-close [mat-dialog-close]="false">
      {{ noText }}
    </button>
    <button class="btn-action" [ngClass]="isDanger ? 'btn-danger' : 'btn-primary'" mat-dialog-close [mat-dialog-close]="true">
      <span>{{ yesText }}</span>
      <mat-icon class="btn-icon" *ngIf="yesIcon">{{ yesIcon }}</mat-icon>
      <mat-icon class="btn-icon" *ngIf="!yesIcon && !hideArrow">arrow_forward</mat-icon>
    </button>
  </div>
</div>
